import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  useNavigate
} from "react-router-dom";
import WarningIcon from "@mui/icons-material/Warning";

// Import your components here
import Home from "./components/home/home";
import GenesysCloudCredentials from "./components/GenesysCloudCredentials";
import MigrationDetails from "./components/MigrationDetails";
import AwsDetails from "./components/awsCredentials";
import SelectMetricsDetails from "./components/SelectMetrics";
import QueueMetricsDetails from "./components/queueMetrics";
import AgentMetricsDetails from "./components/agentMetrics";
import CallRecordingMetricsDetails from "./components/callRecordingMetrics";
import NotFound from "./components/notFound";
import SentimentAnalysisMetricsDetails from "./components/queueMetrics/sentimentAnalysisMetrics";
import Cookie from "./components/footer/cookies";
import Terms from "./components/footer/terms";
import Privacy from "./components/footer/privacy";
import Refreshform from "./components/home/refreshpopup";
import Login from "./components/login/login";
import "./components/routepop.css";
import Faq from "./FAQPage";

const NavigationHandler = ({ setShowModal }) => {
  const location = useLocation();
  // you can use navigate here if needed
  // const navigate = useNavigate();

  useEffect(() => {
    const handlePopState = (event) => {
      event.preventDefault();
      if (location.pathname !== "/") {
        setShowModal(true);
        window.history.pushState(null, null, window.location.href);
      }
    };

    const handleBeforeUnload = (event) => {
      event.preventDefault();
      sessionStorage.setItem("redirectToHome", "true");
      event.returnValue = ""; // required for some browsers to show a confirmation dialog
    };

    window.addEventListener("popstate", handlePopState);
    window.addEventListener("beforeunload", handleBeforeUnload);

    window.history.pushState(null, null, window.location.href);

    if (sessionStorage.getItem("redirectToHome") === "true") {
      sessionStorage.removeItem("redirectToHome");
      if (location.pathname !== "/") {
        setShowModal(true);
        window.history.pushState(null, null, window.location.href);
      }
    }

    return () => {
      window.removeEventListener("popstate", handlePopState);
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [location.pathname, setShowModal]);

  return null;
};

// ✅ Add useNavigate inside Modal
const Modal = ({ showModal, handleClose }) => {
  const navigate = useNavigate(); // 🔹 THIS FIXES navigate is not defined

  if (!showModal) return null;

  return (
    <div className="modal">
      <div className="modal-content">
        <p className="warning-message">
          <WarningIcon /> Going back will discard all the details you’ve entered.
        </p>
        <button onClick={handleClose}>Cancel</button>
        <button
          onClick={() => {
            handleClose();
            navigate("/"); 
          }}
        >
          OK
        </button>
      </div>
    </div>
  );
};

export default function App() {
  const [showModal, setShowModal] = useState(false);

  const handleClose = () => {
    setShowModal(false);
    window.history.pushState(null, null, window.location.href); // prevent back navigation
  };

  return (
    <Router>
      <NavigationHandler setShowModal={setShowModal} />
      <Modal showModal={showModal} handleClose={handleClose} />
      <Routes>
        <Route path="/" element={<Login />} />
        <Route
          path="/Genesys-Cloud-Credentials"
          element={<GenesysCloudCredentials />}
        />
        <Route path="/Aws-Account-Details" element={<AwsDetails />} />
        <Route path="/Migration" element={<MigrationDetails />} />
        <Route path="/Select-Metrics" element={<SelectMetricsDetails />} />
        <Route path="/Queue-Metrics" element={<QueueMetricsDetails />} />
        <Route path="/Agent-Metrics" element={<AgentMetricsDetails />} />
        <Route
          path="/CallRecording-Metrics"
          element={<CallRecordingMetricsDetails />}
        />
        <Route
          path="/Sentiment-Analysis-Metrics"
          element={<SentimentAnalysisMetricsDetails />}
        />
        <Route path="/cookies" element={<Cookie />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/Faq" element={<Faq />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}
